import CustomRefinementTitle from "./CustomRefinementTitle"
import { slideToggle } from "@/helpers/userHelpers";

const url = typeof window != "undefined" && window.location.href;

// filter titles mapping
//OS-5291 filter hide show is now acheived using classes
let attributeTitles = {
  "named_tags.categories.lvl0": "Category",
  "named_tags.categories.lvl1": <CustomRefinementTitle attribute="named_tags.categories.lvl0" />,
  "named_tags.categories.lvl2": <CustomRefinementTitle attribute="named_tags.categories.lvl1" />,
  "meta.color.base_color": "Color",
  "named_tags.Availability": "Availability",
  "meta.custom.us_size": "Size",
  "price": "Price",
  "named_tags.Occasion": "Occasion",
  "named_tags.Style > Sleeves": "Sleeves",
  "vendor": "Designers",
  "named_tags.Material": "Material",
  "named_tags.Stone": "Stone",
  "named_tags.Style > Heel Height": "Heel Height",
  "tags": "Personalization",
};

// attributeTitles = {
//   ...attributeTitles,
//   // "named_tags.Vendor": "Vendor",
// };


export { attributeTitles };

// size sort
const sizesWithPriority = {
  "XXS": 1,
  "XS": 2,
  "XS-S": 3,
  "S": 4,
  "S-M": 5,
  "M": 6,
  "M-L": 7,
  "L": 8,
  "XL": 9,
  "L-XL": 10,
  "XXL": 11
};

// render filter label name
export const renderFilterLabel = (filterAttribute, filterElement) => {
  switch (filterAttribute) {
    case Object.keys(attributeTitles)[1]:
      return filterElement.label.split('>')[1]?.trim();
    case Object.keys(attributeTitles)[2]:
      return filterElement.label.split('>')[filterElement.label.split('>').length - 1]?.trim()
    default:
      return filterElement.label;
  }
}

// render filter label name
export const renderEngraveFilterLabel = (filterElement) => {
  switch (filterElement.label) {
    case 'MORE LETTERS AVAILABLE':
      return 'Letters available';
    case 'MADE TO ORDER':
      return 'Made to order';  
    case 'ENGRAVING AVAILABLE':
      return 'Engraving available'
    default:
      return filterElement.label;
  }
}

// removes all existing refinements on category filter section
const removeExistingCategoryFilters = (existingCategoryRefinements, clearExistingRefinement) => {
  for (let existingCategoryRefinement of existingCategoryRefinements) {
    clearExistingRefinement(existingCategoryRefinement)
  }
}

const handleCategorySectionFiltersForNewArrivalPage = (element, appliedFilters, refine, clearExistingRefinement) => {
  // {existingCategoryRefinements} collects all the existing refinements on category filter section
  const existingCategoryRefinements = appliedFilters.find((elem) => elem.attribute === Object.keys(attributeTitles)[0])?.refinements

  // if the incoming refinement already exists then remove it, else remove all existing and then add the incoming
  if (existingCategoryRefinements.find((existingCategoryRefinement) => existingCategoryRefinement.value === element.value)) {
    removeExistingCategoryFilters(existingCategoryRefinements, clearExistingRefinement)
  }
  else {
    removeExistingCategoryFilters(existingCategoryRefinements, clearExistingRefinement)
    // adds the currently applied refinement on category filter section
    refine(element.value)
  }
}

// removes all existing refinements on level2 / level 3 while changing the category for new Arrival page filter section
const removeExistingFiltersByLevelType = (appliedFilters, clearExistingRefinement, levelType) => {
  switch (levelType) {
    case "LEVEL_2":
      // {level2Refinements} collects all the existing refinements on level2 filter section
      const level2Refinements = appliedFilters.find((elem) => elem.attribute === Object.keys(attributeTitles)[1]).refinements

      // removes all existing refinements on level2 filter section
      for (let level2refinement of level2Refinements) {
        clearExistingRefinement(level2refinement)
      }
      break;
    case "LEVEL_3":
      // {level3Refinements} collects all the existing refinements on level3 filter section
      const level3Refinements = appliedFilters.find((elem) => elem.attribute === Object.keys(attributeTitles)[2]).refinements

      // removes all existing refinements on level3 filter section
      for (let level3Refinement of level3Refinements) {
        clearExistingRefinement(level3Refinement)
      }
      break;
    default:
      break;
  }
}


//  checks whether element is selected or not
export const filterClickHandler = (element, refine, serverRender = false, isNewArrivalPage = false, appliedFilters = [], clearExistingRefinement, attribute) => {
  // if the filter section is category and there exists a refinement on it we need to remove it for new arrival page
  if(serverRender) {
    return true
  }
  if (isNewArrivalPage && appliedFilters?.find((elem) => elem.attribute === Object.keys(attributeTitles)[0]) && attribute === Object.keys(attributeTitles)[0]) {
    if (appliedFilters.length === 1) {
      handleCategorySectionFiltersForNewArrivalPage(element, appliedFilters, refine, clearExistingRefinement)
    }
    else if (appliedFilters.length > 1) {
      handleCategorySectionFiltersForNewArrivalPage(element, appliedFilters, refine, clearExistingRefinement)
      removeExistingFiltersByLevelType(appliedFilters, clearExistingRefinement, "LEVEL_2")
      removeExistingFiltersByLevelType(appliedFilters, clearExistingRefinement, "LEVEL_3")
    }
    else {
      // adds the currently applied refinement on category filter section
      refine(element.value)
    }
  }
  else {
    refine(element.value)
  }
  
  // Scroll to top if not already at top
  if (typeof window !== "undefined" && window.scrollY > 0) {
    window.scrollTo({ top: 0, behavior: "auto" });
  }
};

// this function checks how many items are selected from filter.
export const getSelectedFiltersCount = (ulRef, setAppliedFilterCount) => {
  if (!ulRef || !ulRef.current) {
    return
  }

  let count = '';
  let level = ulRef.current?.dataset?.level;
  let label_val = '';
  if (level === 'type') {
    label_val = ulRef.current.querySelector("input:checked")?.value;
    setAppliedFilterCount(label_val);
  } else {
    count = ulRef.current.querySelectorAll("input:checked").length;
    let str = '';
    if (count) {
      str = count > 1 ? count + ' filters selected' : '1 filter selected';
    }
    return str;
  }
}

//show level 2 filters only when it contains substring of selected level one
export const checkFilterHierarchy = (levelOne, label) => {
  levelOne.map(ele => {
    if (label.includes(ele)) {
      return true;
    }
    else {
      return false;
    }
  })
}

//  handling dropdown for filter category
export const handleDropdownOnFilterCategory = (event) => {
  event.currentTarget.parentElement.classList.toggle('active');
  let nextElementSibling = event.currentTarget.nextElementSibling;

  if (nextElementSibling.classList.contains('search_hide')) {
    nextElementSibling = nextElementSibling.nextElementSibling
  }

  slideToggle(nextElementSibling)
}

// render filter by level type
export const renderFilterByLevelType = (filterAttribute, filterElement, levelType, disableThis, isNewArrivalPage = false) => {
  switch (levelType) {
    case "type":
      return (
        <input
          type='radio'
          name="type_filter"
          value={filterElement.label}
          disabled={filterAttribute === Object.keys(attributeTitles)[0] && !isNewArrivalPage ? 'disabled' : ''}
          checked={filterElement.isRefined ? 'checked' : ''}
          onChange={() => { getSelectedFiltersCount(ulRef, setAppliedFilterCount); }}
        ></input>
      );
    default:
      return (
        <input
          type='checkbox'
          disabled={disableThis}
          checked={filterElement.isRefined ? 'checked' : ''}
          onChange={() => { if (disabledFilter) return; getSelectedFiltersCount(ulRef, setAppliedFilterCount); }}
        ></input>
      )
  }
}

// price range collection to further add into the price filter
//OS-5291 hide 100 and below option
export const priceRangeCollection = [
  { label: '$200 and under', end: 200 },
  { label: '$300 and under', end: 300 },
  { label: '$500 and under', end: 500 },
  { label: '$1000 and under', end: 1000 },
  { label: '$1000 +', start: 1000 },
]

// attributes for breadcrumb
export const breadcrumbAttributes = [
  "named_tags.categories.lvl0",
  "named_tags.categories.lvl1",
  "named_tags.categories.lvl2"
]
export const disableFirstUl = (ulRef) => {
  ulRef.classList.add('disabled');
  ulRef.querySelectorAll('.custom-checkbox').forEach(checkbox => {
    checkbox.querySelector("input").disabled = true;
    checkbox.querySelector("input").classList.add('disabled');
    checkbox.querySelector("label").disabled = true;
  });
}

export const sortSizesFilter = (items) => {
  if (items && Array.isArray(items)) {
    items.sort((a, b) => {
      const sizeA = a.value;
      const sizeB = b.value;

      // Check if the sizes are numeric
      const isNumericA = /^\d+(\.\d+)?$/.test(sizeA);
      const isNumericB = /^\d+(\.\d+)?$/.test(sizeB);

      // Compare sizes based on numeric or alphanumeric nature
      if (isNumericA && isNumericB) {
        // If both sizes are numeric, sort them numerically
        return parseFloat(sizeA) - parseFloat(sizeB);
      }
      //  sizes contains only strings
      else if (sizesWithPriority[sizeA] && sizesWithPriority[sizeB]) {
        return sizesWithPriority[sizeA] - sizesWithPriority[sizeB];
      } else if (sizesWithPriority[sizeA]) {
        return -1;
      } else if (sizesWithPriority[sizeB]) {
        return 1;
      } else if (isNumericA || isNumericB) {
        // If one size is numeric and the other is alphanumeric,
        // numeric size comes first
        return isNumericA ? 1 : -1;
      } else {
        // If both sizes are alphanumeric, extract numeric parts
        const numericPartA = parseFloat(sizeA);
        const numericPartB = parseFloat(sizeB);
        // If both numeric parts are valid numbers, sort them numerically
        if (!isNaN(numericPartA) && !isNaN(numericPartB)) {
          return numericPartA - numericPartB;
        }
        // If none of the above conditions match, sort alphanumerically
        return sizeA.localeCompare(sizeB);
      }
    });
  }
}
